import type { BrowserQueryString } from '@/scopes/common/infrastructure/query-strings/types';

interface Dependencies<T> {
  passThroughParams: (keyof T)[];
  browserQuery: BrowserQueryString;
}

export function passThroughQueryParamHandler<T>({ passThroughParams, browserQuery }: Dependencies<T>) {
  function get(): Partial<T> {
    const queryParams = new URLSearchParams(browserQuery.get() ?? '');
    const result: Partial<T> = {};

    queryParams.forEach((value, key) => {
      if (passThroughParams.includes(key as keyof T)) {
        result[key as keyof T] = value as T[keyof T];
      }
    });
    return result;
  }

  return { get };
}
